import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core';
import {
  agentsRequest,
  deleteAgentsRequest,
} from '../../redux/actions/agents';
import {
  selectAgents,
  selectTotalAgents,
  selectAgentsRequestStatus,
} from '../../redux/selectors/agents';
import Agents from './Agents';
import styles from './styles';
import { AppState } from '../../redux/store';
import { getBuilderId } from "../../redux/selectors/auth";

const mapStateToProps = (state: AppState) => ({
  agents: selectAgents(state),
  agentsTotal: selectTotalAgents(state),
  loading: selectAgentsRequestStatus(state),
  builderId: getBuilderId(state),
});

const mapDispatchToProps = {
  loadAgents: agentsRequest,
  deleteAgents: deleteAgentsRequest,
};

export default withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(Agents));
